<section class="penaltyHistory">
    <div class="TableWrapper scroll thin-scroll-x penaltyHistotyTable">
    <snl-table [useTopScroll]="true" class="expandable-table">
      <snl-row class="headerRow row-bg-color">
          <ng-container *ngFor="let item of penaltyHistoryColumnHeader">
          <snl-th [ngStyle]="{'width': item.width}" [ngClass]="item.value">
            <span class="historyPenltyCol">{{item.name}}</span>
          </snl-th>
        </ng-container>
      </snl-row>
      <snl-row class="distance-row penaltyTableData" *ngFor="let items of getPenaltyHistoryListData">
          <snl-td class="removeBtn" >
            <figure *ngIf="items?.showRemoveButton" class="deleteIcon" (click)="deletePenaltyHistoryEvent(items)">
              <img src="assets/img/deleteIcon.svg" alt="information">
            </figure>         
          </snl-td>
          <snl-td class="penaltyval"  *ngIf="items?.penaltyValue">
            {{items?.penaltyValue}} %
          </snl-td>
          <snl-td class="penaltyval" *ngIf="!items?.penaltyValue">-</snl-td>
          <snl-td class="poolPoints">{{items?.effectivePoolPoints | negativeToBracket}}</snl-td>
          <snl-td class="penaltyFrom" *ngIf="items?.from">{{items?.from | date:'d MMM y, H:mm' : 'UTC' }} UTC</snl-td>
          <snl-td class="penaltyFrom" *ngIf="!items?.from">-</snl-td>
          <snl-td class="penaltyTo" *ngIf="items?.to">{{items?.to | date:'d MMM y, H:mm' : 'UTC' }} UTC</snl-td>
          <snl-td class="penaltyTo" *ngIf="!items?.to">-</snl-td>         
          <snl-td class="duration">{{items?.duration}}</snl-td>
          <ng-container *ngIf="items?.status === 'Removed' || items?.status === 'Ongoing'">
            <!-- <snl-td class="status" [ngClass]="[items?.status === 'Removed' ? 'addRemoveClass' : '',items?.status === 'Ongoing' ? 'addOnGoingClass' : '']"> -->
            <snl-td class="status" >
              <snl-pills  *ngIf="items?.status === 'Ongoing'" [type]="'outline'" [layout]="'success' ">{{items?.status}}</snl-pills>
              <snl-pills *ngIf="items?.status === 'Removed'" [type]="'outline'" [layout]="'neutral'">{{items?.status}}</snl-pills>
            </snl-td>
          </ng-container>
          <ng-container *ngIf="items?.status === 'Ended'">
            <snl-td class="status" ></snl-td>
          </ng-container>
          <snl-td class="reason">
            {{items?.penaltyReason}}
            <span class="removalDateWrap" *ngIf="items?.status === 'Removed'">
              <span class="removedDate">
                <span class="removedDateValue">Removed on:</span>
                <span class="removedDateText">{{items?.penaltyRemovalDate | date:'d MMM y': 'UTC' }}
                </span>
              </span>
              <span class="removalReason">
                <span class="removalReasonValue">Reason for removal:</span>
                <span class="removalReasonText">{{items?.penaltyRemovalReason}}</span>
              </span>
            </span>
          </snl-td>
          <snl-td class="date">
            <span class="userName">{{items?.lastUpdatedByFirstName}} {{items?.lastUpdatedByLastName}}</span>
            <span class="userNameInitials">({{items?.lastUpdatedByInitials}})</span>
            <span class="userEmail">{{items?.lastUpdatedByUser | lowercase}}</span>
          </snl-td>
      </snl-row>
       
    </snl-table>
  </div>
</section>

<ng-container *ngIf="deletePenalty">
  <snl-modal (click)="deletePenalty = false" [type]="'large'" [open]="deletePenalty">
  <div slot="heading" class="ppLargeModalHeading"> Remove Penalty </div>
  <div slot="modalContent" class="modal-content">
     <div class="removePenalty penaltyHistoryModal">
            <div class="textWrap">
                <div class="body-b1">You are about to remove the following penalty:</div>
                <ul class="body-b1">
                    <li>Value: {{deletePenaltyModalData?.penaltyValue}} %</li>
                    <li>Effective pool points: {{deletePenaltyModalData?.effectivePoolPoints}}</li>
                    <li>From date: {{deletePenaltyModalData?.from | date:'d MMM y, H:mm' : 'UTC' }} UTC</li>
                    <li>To date:  {{deletePenaltyModalData?.to | date:'d MMM y, H:mm' : 'UTC' }} UTC</li>
                    <li>Duration: {{deletePenaltyModalData?.duration}}</li>
                </ul>
                <br>
                <div class="body-b1 floatClassLeft">
                    <ng-container *ngIf="deletePenaltyModalData?.alreadyUsedInCalculation">
                        Removing this penalty <span class="notAffect sub-heading-s1">will not affect distribution</span> calculation for
                        pool {{penaltyHistoryPool}} and ship <span class="shipName sub-heading-s1">{{penaltyHistoryShip}}</span>.
                        Are you sure you want to remove it?
                    </ng-container>
                    <ng-container *ngIf="!deletePenaltyModalData?.alreadyUsedInCalculation">
                        This will affect distribution calculation for <span class="poolVal sub-heading-s1">Pool {{penaltyHistoryPool}}</span> and ship <span class="shipName sub-heading-s1">{{penaltyHistoryShip}}</span> in the months of 
                        <ng-container *ngIf="deletePenaltyModalData?.effectedMonths?.length < 2">
                          <span class="date sub-heading-s1">{{deletePenaltyModalData?.effectedMonths + '-01' | date:'MMM' }} {{currentYear}}</span>
                        </ng-container> 
                         <ng-container *ngIf="deletePenaltyModalData?.effectedMonths?.length > 1">
                          <span class="date sub-heading-s1">{{ getMonthShort(deletePenaltyModalData?.effectedMonths[0]) }} to {{ getMonthShort(deletePenaltyModalData?.effectedMonths[deletePenaltyModalData?.effectedMonths.length - 1]) }} {{currentYear}}</span>
                        </ng-container> 
                        . Are you sure you want to remove it?
                    </ng-container>
                </div>       
            </div>
            <div class="floatClassRight">
              <snl-multi-line-input class="penaltyReason-height"
                [label]="'Reason for removal'"
                [maxLength]="250"
                [isError]="isError"
                (fieldValue)="penaltyHistoryFieldVal($event)"
              >
            </snl-multi-line-input>
            </div>
           
        </div>
  </div>
  <div slot="modalFooter">
    <div class="btnWrap">
      <snl-button type="secondary" size="large" (click)="cancelDeletePenalty()">Cancel</snl-button>
      <snl-button type="primary" class="errorCalc" size="large" [ngClass]="!removePenaltyHistoryReason ? 'disabledClass' : ''" [disabled]="!removePenaltyHistoryReason"  (click)="deletePenalty = false;penaltyRemoved()">Yes, remove</snl-button>                 
                 
    </div>
  </div>
</snl-modal>
</ng-container>
